require('../src/components/store/content/static/fonts/Vermarc-Fonts.css');
require('../src/components/store/content/static/fonts/Icons.css');
